import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import _ from "lodash";

import { _fetchSubmittedTimesheetList } from "@/services/timesheet";

import { formatTimesheets } from "../../utilities/dataFormatter";
const initialState = {
  isLoading: false,
  isPaginationLoading: false,
  submittedTimesheets: [],
  selectedCandidate: [], // list of candidate id
  selectedSignOffIds: [], // list of signoff ids
  filters: {
    search: "",
    sessionType: [],
    candidateReferenceNo: "",
    contractReferenceNo: "",
    candidateId: [],
    candidateRole: null,
    complianceStatus: null,
    miles: null,
    candidateLicenseNo: "",
    candidatePostcode: "",
    workedDateFrom: "",
    workedDateTo: "",
    contractDateFrom: "",
    contractDateTo: "",
  },
  totalCount: 0,
  isSelectedAll: false,
  oldFilters: {},
  pagination: {
    currentPage: 1,
    totalPage: 1,
    isLastPage: false,
  },
  sorting: {
    sortByColumn: "",
    sortByOrder: "",
  },
  showRejectModal: false,
  showAdjustAmendmentModal: false,
  adjustAmendMentData: {},
  showFilters: false,
  toggleSelected: false,
};

export const fetchSubmittedTimesheets = createAsyncThunk(
  "timesheetsSubmitted/fetchSubmittedTimesheets",
  async (data, { dispatch, getState }) => {
    const {
      clientTimesheetSubmitted: {
        filters,
        pagination,
        sorting,
        submittedTimesheets,
      },
    } = getState();
    if (_.isEmpty(data)) {
      data = {
        ...filters,
      };
    }
    if (pagination.isLastPage) {
      return dispatch(setSubmittedTimesheetsLoading(false));
    }

    dispatch(setPaginationLoading(pagination.currentPage !== 1));
    dispatch(toggleSelectedAll(false));

    const _data = {
      ...data,
      currentPage: pagination.currentPage,
      ...sorting,
      timesheetType: "submitted",
    };

    let response = _fetchSubmittedTimesheetList(_data);
    response
      .then((res) => {
        const {
          data: { timesheet_list, meta },
        } = res;
        const { currentPage, lastPage, isLastPage, total: totalCount } = meta;
        let data = formatTimesheets(timesheet_list, 0);
        dispatch(
          updatePagination({
            currentPage: currentPage + 1,
            totalPage: lastPage,
            isLastPage: isLastPage,
          }),
        );

        let prevList = currentPage === 1 ? [] : _.uniq(submittedTimesheets);

        let firstsign_off_id = data.length > 0 ? data[0].sign_off_id : null;

        dispatch(updateTotalCount(totalCount));

        if (
          prevList.length > 0 &&
          prevList.find((item) => item.sign_off_id === firstsign_off_id) !==
            undefined
        ) {
          //
        } else {
          dispatch(updateSubmittedTimesheets([...prevList, ...data]));
        }
        return res;
      })
      .catch((error) => {
        // handleAPICatch(error);
      })
      .finally(() => {
        setTimeout(() => {
          dispatch(setSubmittedTimesheetsLoading(false));
          dispatch(setPaginationLoading(false));
        }, 10);
      });
  },
);

const timesheetsSubmittedSlice = createSlice({
  name: "timesheetsSubmitted",
  initialState,
  reducers: {
    updateSubmittedTimesheets: (state, action) => {
      state.submittedTimesheets = action.payload;
    },
    setSubmittedTimesheetsLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    setPaginationLoading(state, action) {
      state.isPaginationLoading = action.payload; // New reducer for pagination loading
    },
    updateSelectedCandidate: (state, action) => {
      state.selectedCandidate = action.payload;
      if (action.payload.length === 0) {
        state.isSelectedAll = false;
      }
    },
    updateSelectedSignOffIds: (state, action) => {
      state.selectedSignOffIds = action.payload;
    },
    deSelectAllCandidate: (state) => {
      state.selectedCandidate = [];
      state.selectedSignOffIds = [];
      state.isSelectedAll = false;
    },
    updateFilters: (state, action) => {
      if (_.isEmpty(action.payload)) {
        state.filters = {
          search: state.filters.search,
          ...initialState.filters,
        };
        return;
      } else {
        if (action.payload.reset) {
          state.filters = initialState.filters;
        } else {
          state.filters = { ...state.filters, ...action.payload };
        }
      }
    },
    updatePagination: (state, action) => {
      state.pagination = {
        ...state.pagination,
        ...action.payload,
      };
    },
    updateSorting: (state, action) => {
      state.sorting = action.payload;
    },
    toggleRejectModal: (state, action) => {
      state.showRejectModal = action.payload;
    },
    toggleAdjustAmendmentModal: (state, action) => {
      state.showAdjustAmendmentModal = action.payload;
    },
    updateAdjustAmendmentData: (state, action) => {
      state.adjustAmendMentData = action.payload;
    },
    showFilterModal: (state, action) => {
      if (action.payload) {
        state.oldFilters = state.filters;
      }
      state.showFilters = action.payload;
    },
    updateToggleSelected: (state, action) => {
      state.toggleSelected = !state.toggleSelected;
    },
    reStateFilters: (state, action) => {
      state.filters = state.oldFilters;
    },
    updateTotalCount: (state, action) => {
      state.totalCount = action.payload;
    },
    toggleSelectedAll: (state, action) => {
      state.isSelectedAll = action.payload;
    },
  },
});

export const {
  updateSubmittedTimesheets,
  setSubmittedTimesheetsLoading,
  setPaginationLoading,
  updateSelectedCandidate,
  updateSelectedSignOffIds,
  deSelectAllCandidate,
  updateFilters,
  updateSorting,
  updatePagination,
  toggleRejectModal,
  toggleAdjustAmendmentModal,
  updateAdjustAmendmentData,
  showFilterModal,
  updateToggleSelected,
  reStateFilters,
  updateTotalCount,
  toggleSelectedAll,
} = timesheetsSubmittedSlice.actions;

export default timesheetsSubmittedSlice.reducer;
